(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["RelatedBlogs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide !== 'undefined') {

    // Loop through all related-blog-splide sections (if multiple)
    document.querySelectorAll('.related-blog-posts').forEach(function(section) {
      var splideEl = section.querySelector('.related-blog-splide');

      if (!splideEl) return;

      var splide = new Splide(splideEl, {
        type: 'loop',
        perPage: 4,
        gap: '20px',
        arrows: false,
        pagination: false,
        breakpoints: {
          576: { perPage: 1 },
          768: { perPage: 2 },
          1024: { perPage: 3 }
        }
      }).mount();

      // Custom arrows within this section
      var prevBtn = section.querySelector('.splide__arrow--prev');
      var nextBtn = section.querySelector('.splide__arrow--next');

      if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });
    });

  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-blog-posts"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide !== 'undefined') {

    // Loop through all related-blog-splide sections (if multiple)
    document.querySelectorAll('.related-blog-posts').forEach(function(section) {
      var splideEl = section.querySelector('.related-blog-splide');

      if (!splideEl) return;

      var splide = new Splide(splideEl, {
        type: 'loop',
        perPage: 4,
        gap: '20px',
        arrows: false,
        pagination: false,
        breakpoints: {
          576: { perPage: 1 },
          768: { perPage: 2 },
          1024: { perPage: 3 }
        }
      }).mount();

      // Custom arrows within this section
      var prevBtn = section.querySelector('.splide__arrow--prev');
      var nextBtn = section.querySelector('.splide__arrow--next');

      if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });
    });

  }
});

  } catch(e) { console.error(e); }
})();
})();
